import React from "react"
import { useGetMedicalInfo, useMedicalInfo } from "../../context/MedicalInfoContext"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"
import { Form } from "@carrotfertility/carotene-core-x"
import {
  ButtonFooterLayout,
  ContinueButton,
  RoutingFlowTitle,
  SkipButton,
  StepLayout,
  useConvertTranslatedLabel
} from "#/components/carrot-plans/shared"
import { FormRadioButtonGroup } from "#/services/common-forms"

export default function BiologicalChildrenStep(): JSX.Element {
  const { updateMedicalInfo, hasQuestionBeenSkipped } = useMedicalInfo()
  const { data: medicalInfo } = useGetMedicalInfo(false)
  const defaultValue = medicalInfo?.biologicalChildren
  const intl = useIntl()

  const { send } = useStateMachine(defaultValue || hasQuestionBeenSkipped("biologicalChildren") ? "" : null)
  const buttonOptions = [
    { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
    { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
  ]
  const radioOptions = useConvertTranslatedLabel(buttonOptions)

  async function onClickContinue(formValues: { biologicalChildren: string }): Promise<void> {
    if (formValues?.biologicalChildren !== null) {
      await updateMedicalInfo({ biologicalChildren: formValues.biologicalChildren })
      send("")
    } else {
      await onSkip()
    }
  }

  async function onSkip(): Promise<void> {
    await updateMedicalInfo({ skipFields: ["biologicalChildren"] })
    send("")
  }

  const header = intl.formatMessage({
    defaultMessage: "Have you had genetically related children before?"
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={<span id="biologicalChildren-label">{header}</span>}
        formElements={
          <Form onSubmit={onClickContinue} defaultValues={{ biologicalChildren: defaultValue }}>
            <FormRadioButtonGroup
              name="biologicalChildren"
              options={radioOptions}
              aria-labelledby="biologicalChildren-label"
            />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
              skipButton={<SkipButton onClick={onSkip} />}
            />
          </Form>
        }
      />
    </>
  )
}
